export const NETWORK_OFFLINE = 'NETWORK_OFFLINE';
export const THREAD_HISTORY_FAILED = 'THREAD_HISTORY_FAILED';
export const CREATE_NEW_THREAD_FAILED = 'CREATE_NEW_THREAD_FAILED';
export const SUBSCRIPTIONS_FAILED = 'SUBSCRIPTIONS_FAILED';
export const PUBSUB_FAILED = 'PUBSUB_FAILED';